import * as Styles from './LinkText.styles';

export interface LinkTextProps {
  value: string | number;
}

export const LinkText = ({ value }: LinkTextProps) => <span className={Styles.value}>{value}</span>;
